var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { parseGraphqlResult } from 'shared/domains/apollo/parseGraphqlResult';
import { useAccount } from 'shared/domains/users';
import { NewContactDocument } from './NewContact.gql';
import { ContactForm } from '../ContactForm';
import { ContactLibraryListDocument } from '../ContactLibraryList.gql';
import { rejectionMessage } from '../rejectionMessage';
export function NewContact(props) {
    const { onSuccess, onClose } = props;
    const { addToast } = useToast();
    const [rejections, setRejections] = useState([]);
    const [mutate] = useMutation(NewContactDocument);
    const account = useAccount();
    const { companyId, userId } = account.data;
    const updateContact = (values) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { firstName, lastName, email, mobile, title, label, authenticationMode, isPublic = false } = values;
        if (!userId || !companyId) {
            throw new Error('Missing userId or companyId');
        }
        const result = yield mutate({
            refetchQueries: [ContactLibraryListDocument],
            variables: {
                input: {
                    userId,
                    companyId,
                    firstName,
                    lastName,
                    email,
                    title,
                    mobile,
                    label,
                    authenticationMode,
                    isPublic,
                },
            },
        });
        const [, rejectionReasons] = parseGraphqlResult((_a = result.data) === null || _a === void 0 ? void 0 : _a.createEsigningRecipientValue, 'CreateEsigningRecipientValuePayload', 'CreateEsigningRecipientValueRejectionList');
        if (rejectionReasons === null || rejectionReasons === void 0 ? void 0 : rejectionReasons.rejections.length) {
            setRejections(rejectionReasons === null || rejectionReasons === void 0 ? void 0 : rejectionReasons.rejections.map((rejection) => rejectionMessage(rejection.reason)));
            return;
        }
        addToast({
            title: t({
                message: 'Contact created',
                comment: 'Contact library - Contact created toast',
            }),
            message: t({
                message: 'Your new contact has been added to the contact library. You can add them as a recipient now.',
                comment: 'Contact library - Contact created toast message',
            }),
            appearance: 'success',
            action: {
                label: t({
                    message: 'Add as recipient',
                    comment: 'Contact library - Add as recipient button label',
                }),
                onClick: () => {
                    onSuccess(values);
                },
            },
        });
        onClose();
    });
    return <ContactForm rejections={rejections} onClose={onClose} onSubmit={(values) => updateContact(values)}/>;
}
